import moment from "moment";
import { useEffect, useState } from "react";
import { Button, Dropdown, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  showErrorToastMessage,
  showSuccessToastMessage,
} from "../../../../component/Toasts/Toasts";
import * as actions from "../../../../Redux/Actions/index";
import { AiOutlineCheck } from "react-icons/ai";
import Select from "react-select";
import {
  Strings,
  projectDetailsLabels,
  requiredFeild,
  addProjectErrorsValidations,
  geographyDropdown,
  projectTypeDropdown,
  techTypeDropdown,
  addProjectStatusDropdown,
  poValueInDropdown,
  billingRateDropdown,
} from "../../../../constant/Strings";
import {
  isEmailValid,
  isMobileValid,
  projectClientNameValidation,
  projectLocationValidation,
  projectPoNumberValidation,
  projectProjectCodeValidation,
  projectProjectNameValidation,
  projectSubProjectCodeValidation,
  employeeMobileNumberValidtion,
  projectCustomerCodeValidation,
  containsInvalidChars,
} from "../../../../constant/Validations";
import "../ProjectRepository.scss";
import { BsCheckLg, BsXLg, BsGear } from "react-icons/bs"; 
import { InputGroup, Spinner } from "react-bootstrap"; 
import ClientManagerModal from "../../../../component/ModalComponent/ClientManagerModal";

const AddProject = (props: any) => {
  const isHrAdmin = (localStorage.getItem("role") || "").includes("hr-admin");
  const {
    hideAddProject,
    apiCallCompleted,
    setnextScreen,
    setAddDocModalData,
  } = props;
  const { cancel, submit, addSuccess, invalidCharsError } = Strings;
  const [btnDisable, setBtnDisable] = useState(false);

  const {
    poNumber,
    subProjectCode,
    customerCode,
    projectCode,
    projectName,
    location,
    spocPersonName,
    spocNumber,
    spocEmail,
  } = addProjectErrorsValidations;

  const {
    geographyLabel,
    locationLabel,
    clientNameLabel,
    projectNameLabel,
    projectTypeLabel,
    projectCodeLabel,
    subProjectCodeLabel,
    CustomerCodeLabel,
    serviceLineLabel,
    deliveryManagerLabel,
    hrBusinessPartnerLabel,
    projectStartDateLabel,
    projectEndDateLabel,
    projectStatusLabel,
    purchaseOrderNoLabel,
    poStartDateLabel,
    poEndDateLabel,
    approvedHcLabel,
    currencyTypeLabel,
    billingStatusLabel,
    billingRateLabel,
    spocPersonNameLabel,
    spocContactNumberLabel,
    spocEmailIDLabel,
    remarksLabel,
  } = projectDetailsLabels;

  const [projectData, setProjectData] = useState<any>({
    geography: "",
    location: "",
    client: "",
    projectName: "",
    projectCode: "",
    subProjectName: "",
    subProjectCode: "",
    customerCode: "",
    // projectStartDate: "",
    // projectEndDate: "",
    tdm: "",
    hrbpRef: "",
    // status: "",
    projectType: "",
    techType: "",
    // poNumber: "",
    poDate: "",
    approvedHc: "",
    // poValueIn: "",
    // billingRate: "",
    // poAmount: "",
    monthlyBilling: "",
    spocPersonName: "",
    spocNumber: "",
    spocEmail: "",
    // poStartDate: "",
    // poEndDate: "",
    projectDescription: "",
    actualHc: "",
    buHeadRef: "",
  });

  const [errors, setErrors] = useState({
    location: "",
    client: "",
    projectName: "",
    projectCode: "",
    subProjectName: "",
    subProjectCode: "",
    customerCode: "",
    tdm: "",
    techType: "",
    poNumber: "",
    approvedHc: "",
    poAmount: "",
    spocPersonName: "",
    spocNumber: "",
    spocEmail: "",
    projectDescription: "",
    actualHc: "",
  });

  const dispatch = useDispatch();
  let valid: boolean = true;
  const validate = () => {
    if (
      projectData.location != "" &&
      projectLocationValidation(projectData.location) == false
    ) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        location: location,
      }));
      setBtnDisable(false);
    } else {
      setErrors((errorObj) => ({
        ...errorObj,
        location: "",
      }));
    }

    if (projectProjectNameValidation(projectData.projectName) == false) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        projectName: projectName,
      }));
      setBtnDisable(false);
    } else {
      setErrors((errorObj) => ({
        ...errorObj,
        projectName: "",
      }));
    }
    if (projectProjectCodeValidation(projectData.projectCode) == false) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        projectCode: projectCode,
      }));
      setBtnDisable(false);
    } else {
      setErrors((errorObj) => ({
        ...errorObj,
        projectCode: "",
      }));
    }
    if (projectSubProjectCodeValidation(projectData.subProjectCode) == false) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        subProjectCode: subProjectCode,
      }));
      setBtnDisable(false);
    } else {
      setErrors((errorObj) => ({
        ...errorObj,
        subProjectCode: "",
      }));
    }

    if (projectCustomerCodeValidation(projectData.customerCode) == false) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        customerCode: customerCode,
      }));
      setBtnDisable(false);
    } else {
      setErrors((errorObj) => ({
        ...errorObj,
        customerCode: "",
      }));
    }

    // if (projectPoNumberValidation(projectData.poNumber) == false) {
    //   valid = false;
    //   setErrors((errorObj) => ({
    //     ...errorObj,
    //     poNumber: poNumber,
    //   }));
    //   setBtnDisable(false);
    // } else {
    //   setErrors((errorObj) => ({
    //     ...errorObj,
    //     poNumber: "",
    //   }));
    // }

    if (projectData.spocPersonName) {
      if (projectClientNameValidation(projectData.spocPersonName) == false) {
        valid = false;
        setErrors((errorObj) => ({
          ...errorObj,
          spocPersonName: spocPersonName,
        }));
        setBtnDisable(false);
      } else {
        setErrors((errorObj) => ({
          ...errorObj,
          spocPersonName: "",
        }));
      }
    }
    if (projectData.spocNumber) {
      if (
        projectData.geography === "India" &&
        isMobileValid(projectData.spocNumber) == false
      ) {
        valid = false;
        setErrors((errorObj) => ({
          ...errorObj,
          spocNumber: spocNumber,
        }));
        setBtnDisable(false);
      } else if (
        projectData.geography !== "India" &&
        employeeMobileNumberValidtion(projectData.spocNumber) == false
      ) {
        valid = false;
        setErrors((errorObj) => ({
          ...errorObj,
          spocNumber: spocNumber,
        }));
        setBtnDisable(false);
      } else {
        setErrors((errorObj) => ({
          ...errorObj,
          spocNumber: "",
        }));
      }
    }
    if (projectData.spocEmail) {
      if (isEmailValid(projectData.spocEmail) == false) {
        valid = false;
        setErrors((errorObj) => ({
          ...errorObj,
          spocEmail: spocEmail,
        }));
        setBtnDisable(false);
      } else {
        setErrors((errorObj) => ({
          ...errorObj,
          spocEmail: "",
        }));
      }
    }
  };
  const handleInvoiceSubmit = () => {
    validate();
    if (valid) {
      handleDispatch();
      hideAddProject();
    }
  };
  const handleDispatch = () => {
    const userLogin: any = localStorage.getItem("login");
    const loginId = JSON.parse(userLogin)?.id;
    const payload = {
      ...projectData,
      PoAddedBy: loginId,
    };
    setBtnDisable(false);
    apiCallCompleted(false);
    dispatch(
      actions.addProjectRepositoryAction(payload, (res: any) => {
        if (res?.error?.error_description) {
          apiCallCompleted(true);
          showErrorToastMessage(res.error.error_description);
        } else if (res.code === 200) {
          apiCallCompleted(true);
          setAddDocModalData({ ...payload });
          showSuccessToastMessage("Project added successfully!");
          // setnextScreen(true);
        }
      })
    );
  };

  const addClientName = useSelector(
    (state: any) => state.employeeReducer.addClientNameDetails
  );
  useEffect(() => {
    dispatch(actions.getClientNameAction());
  }, [addClientName]);

  const [client, setClient] = useState({
    clientName: "",
  });
  const handleDropDownClientSubmit = (e: any) => {
    e.preventDefault();
    dispatch(
      actions.addClientNameAction(client, (res: any) => {
        if (res?.error?.error_description) {
          showErrorToastMessage(res.error.error_description);
        } else if (res.code === 200) {
          showSuccessToastMessage(addSuccess);
        }
      })
    );

    const inputField: any = document.getElementById("formAddOption");
    if (inputField) {
      inputField.value = "";
    }
  };

  const [clientName, setClientName] = useState([]);
  const [employeeInfo, setEmployeeInfo] = useState([]);
  const [hrbpInfo, setHrbpInfo] = useState([]);
  const [clientOptions, setClientOptions] = useState<any[]>([]);
  const [isAddingClient, setIsAddingClient] = useState(false);
  const [newClientName, setNewClientName] = useState("");
  const [isSubmittingClient, setIsSubmittingClient] = useState(false);
  const [showClientManager, setShowClientManager] = useState(false);

  const getClientName = useSelector(
    (state: any) => state.employeeReducer.getClientNameDetails
  );
  
  useEffect(() => {
    dispatch(actions.getClientNameAction());
  }, [dispatch]);

  useEffect(() => {
    if (getClientName && getClientName.data) {
      setClientOptions(getClientName.data);
    }
  }, [getClientName]);

  useEffect(() => {
    if (projectData.client && clientOptions.length > 0) {
      const exists = clientOptions.some(c => c.clientName === projectData.client);
      if (!exists) {
         setProjectData((prev: any) => ({ ...prev, client: "", clientRef: "" }));
      }
    }
  }, [clientOptions, projectData.client]);

  const employeeManagerData = useSelector(
    (state: any) => state.employeeReducer.getEmployeeData
  );
  useEffect(() => {
    if (getClientName && getClientName.data) {
      setClientName(getClientName.data);
    }
    if (employeeManagerData && employeeManagerData.data) {
      setEmployeeInfo(employeeManagerData.data);
    }
  }, [getClientName, employeeManagerData]);
  useEffect(() => {
    dispatch(actions.getEmployeeDataAction());
  }, []);
  useEffect(() => {
    dispatch(actions.getEmployeeDbHrbpListAction());
  }, []);

  const employeeHrbpData = useSelector(
    (state: any) => state.employeeReducer.getEmployeeDbHrbpList
  );
  useEffect(() => {
    if (employeeHrbpData && employeeHrbpData.data) {
      setHrbpInfo(employeeHrbpData.data);
    }
  }, [employeeHrbpData, hrbpInfo]);
  useEffect(() => {
    if (
      projectData.geography &&
      // projectData.location &&
      projectData.client &&
      projectData.projectName &&
      projectData.projectCode &&
      projectData.subProjectCode &&
      projectData.customerCode &&
      // projectData.projectStartDate &&
      projectData.buHeadRef &&
      projectData.hrbpRef &&
      // projectData.status &&
      projectData.projectType
    ) {
      setBtnDisable(true);
    } else {
      setBtnDisable(false);
    }
  });

  const managerOptions: any = employeeInfo.map((ele: any) => ({
    value: ele._id,
    label: ele.middleName
      ? ele.candidateName +
        " " +
        ele.middleName +
        " " +
        ele.lastname +
        "-" +
        ele.employeeId
      : ele.candidateName + " " + ele.lastname + "-" + ele.employeeId,
    hrbp: ele?.hrbpData?.[0],
  }));

  const handleReportingManager = (selected: any) => {
    const hrbpName = `${selected?.hrbp?.candidateName ?? ""} ${selected?.hrbp
      ?.middleName ?? ""} ${selected?.hrbp?.lastname ?? ""} - ${selected?.hrbp
      ?.employeeId ?? ""}`;
    setProjectData({
      ...projectData,
      buHeadRef: selected.value,
      hrbp: hrbpName,
    });
  };

  const hrbpOptions: any = hrbpInfo.map((ele: any) => ({
    value: ele._id,
    label: ele.middleName
      ? ele.candidateName +
        " " +
        ele.middleName +
        " " +
        ele.lastname +
        "-" +
        ele.employeeId
      : ele.candidateName + " " + ele.lastname + "-" + ele.employeeId,
  }));
  const handleAddNewClient = () => {
    if (!newClientName.trim()) return;
     if (containsInvalidChars(newClientName)) { showErrorToastMessage(invalidCharsError); return; }

    setIsSubmittingClient(true);
    dispatch(actions.addClientNameAction({ clientName: newClientName }, (res: any) => {
      setIsSubmittingClient(false);
      
      // Success Check
      if (res?.data || res?.code === 200) {
        dispatch(actions.getClientNameAction()); // Refresh list
        
        const addedName = res?.data?.clientName || newClientName;
        const addedId = res?.data?._id || "";

        setClientOptions(prev => [...prev, res.data || { clientName: newClientName }]);
        setProjectData((prev: any) => ({ 
            ...prev, 
            client: addedName, 
            clientRef: addedId 
        }));
        
        setIsAddingClient(false);
        setNewClientName("");
      } else {
        const errorMsg = res?.error?.response?.data?.error?.error_description || "Failed to add client";
        showErrorToastMessage(errorMsg);
      }
    }) as any);
  };

  const handleHrbpManager = (selected: any) => {
    setProjectData({
      ...projectData,
      hrbpRef: selected.value,
    });
  };
  return (
    <>
      <div className="row g-3">
        <div className="col-md-4">
          <label htmlFor="inputName4" className="form-label">
            {geographyLabel}
          </label>
          <span className="required">{requiredFeild.required}</span>
          <Dropdown
            onSelect={(eventKey: any) =>
              setProjectData({
                ...projectData,
                geography: eventKey,
              })
            }
          >
            <Dropdown.Toggle variant="light" className="form-control">
              {projectData.geography}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {geographyDropdown.map((element: any) => (
                <Dropdown.Item eventKey={element}>{element}</Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div className="col-md-4">
          <label htmlFor="inputName4" className="form-label">
            {locationLabel}
          </label>
          {/* <span className="required">{requiredFeild.required}</span> */}
          <input
            type="text"
            className="form-control"
            value={projectData.location}
            onChange={(e) =>
              setProjectData({
                ...projectData,
                location: e.target.value,
              })
            }
          />
          <p className="error">{errors.location}</p>
        </div>
        <div className="col-md-4">
          <label htmlFor="inputName4" className="form-label">
            {clientNameLabel}
          </label>
          <span className="required">{requiredFeild.required}</span>
          
          {isAddingClient ? (
            <InputGroup className="mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Enter new client"
                value={newClientName}
                onChange={(e) => setNewClientName(e.target.value)}
                autoFocus
              />
              <Button variant="primary" onClick={handleAddNewClient} disabled={isSubmittingClient}>
                {isSubmittingClient ? <Spinner size="sm" animation="border" /> : <BsCheckLg />}
              </Button>
              <Button variant="outline-secondary" onClick={() => setIsAddingClient(false)}>
                <BsXLg />
              </Button>
            </InputGroup>
          ) : (
            <Dropdown
                onSelect={(key: any) => {
                    if (key === "__ADD__") setIsAddingClient(true);
                    else if (key === "__MANAGE__") setShowClientManager(true);
                    else {
                        // Find the full object to get ID
                        const selectedObj = clientOptions.find((c: any) => c.clientName === key);
                        setProjectData({
                            ...projectData,
                            client: key,
                            clientRef: selectedObj ? selectedObj._id : ""
                        });
                    }
                }}
            >
                <Dropdown.Toggle variant="light" className="form-control text-start d-flex justify-content-between align-items-center">
                    {projectData.client ? `${projectData.client.slice(0, 30)}${projectData.client.length > 30 ? '...' : ''}` : "Select..."}
                </Dropdown.Toggle>
                <Dropdown.Menu className="w-100" style={{maxHeight: '300px', overflowY: 'auto'}}>
                  {isHrAdmin && (
                        <>
                    <Dropdown.Item eventKey="__ADD__" className="text-primary fw-bold">+ Add New Client</Dropdown.Item>
                    {/* <Dropdown.Item eventKey="__MANAGE__" className="text-secondary"><BsGear /> Manage Clients</Dropdown.Item> */}
                    <Dropdown.Divider />
                    </>
                  )}
                    {clientOptions.length > 0 ? (
                        clientOptions.map((ele: any) => (
                            <Dropdown.Item key={ele._id} eventKey={ele.clientName}>
                                {ele.clientName}
                            </Dropdown.Item>
                        ))
                    ) : (
                        <Dropdown.Item disabled>No clients found</Dropdown.Item>
                    )}
                </Dropdown.Menu>
            </Dropdown>
          )}
          <p className="error">{errors.client}</p>
        </div>

        <div className="col-md-4">
          <label htmlFor="inputName4" className="form-label">
            {projectNameLabel}
          </label>
          <span className="required">{requiredFeild.required}</span>
          <input
            type="text"
            className="form-control"
            value={projectData.projectName}
            onChange={(e) =>
              setProjectData({
                ...projectData,
                projectName: e.target.value,
              })
            }
          />
          <p className="error">{errors.projectName}</p>
        </div>

        <div className="col-md-4">
          <label htmlFor="inputName4" className="form-label">
            Project Description
          </label>
          <textarea
            maxLength={150}
            className="form-control"
            value={projectData.projectDescription}
            onChange={(e) =>
              setProjectData({
                ...projectData,
                projectDescription: e.target.value.slice(0, 150),
              })
            }
          />
          <p className="error">{errors.projectDescription}</p>
        </div>

        <div className="col-md-4">
          <label htmlFor="inputName4" className="form-label">
            {projectTypeLabel}
          </label>
          <span className="required">{requiredFeild.required}</span>
          <Dropdown
            onSelect={(eventKey: any) =>
              setProjectData({
                ...projectData,
                projectType: eventKey,
              })
            }
          >
            <Dropdown.Toggle variant="light" className="form-control">
              {projectData.projectType}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {projectTypeDropdown.map((element: any) => (
                <Dropdown.Item eventKey={element}>{element}</Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>

        <div className="col-md-4">
          <label htmlFor="inputName4" className="form-label">
            {projectCodeLabel}
          </label>
          <span className="required">{requiredFeild.required}</span>
          <input
            type="text"
            className="form-control"
            value={projectData.projectCode}
            onChange={(e) => {
              const value = e.target.value;
              const sanitizedValue = value
                .replace(/[^&().a-zA-Z0-9\s-]/g, "")
                .replace(/^\s+/, "")
                .replace(/\s{2,}/g, " ");
              setProjectData({
                ...projectData,
                projectCode: sanitizedValue,
              });
            }}
          />
          <p className="error">{errors.projectCode}</p>
        </div>
        <div className="col-md-4">
          <label htmlFor="inputName4" className="form-label">
            {subProjectCodeLabel}
          </label>
          <span className="required">{requiredFeild.required}</span>
          <input
            type="text"
            className="form-control"
            value={projectData.subProjectCode}
            onChange={(e) =>
              setProjectData({
                ...projectData,
                subProjectCode: e.target.value,
              })
            }
          />
          <p className="error">{errors.subProjectCode}</p>
        </div>

        <div className="col-md-4">
          <label htmlFor="inputName4" className="form-label">
            {CustomerCodeLabel}
          </label>
          <span className="required">{requiredFeild.required}</span>
          <input
            type="text"
            className="form-control"
            value={projectData?.customerCode}
            onChange={(e) =>
              setProjectData({
                ...projectData,
                customerCode: e.target.value,
              })
            }
          />
          <p className="error">{errors.customerCode}</p>
        </div>

        <div className="col-md-4">
          <label htmlFor="inputName4" className="form-label">
            {serviceLineLabel}
          </label>
          <Dropdown
            onSelect={(eventKey: any) =>
              setProjectData({
                ...projectData,
                techType: eventKey,
              })
            }
          >
            <Dropdown.Toggle variant="light" className="form-control">
              {projectData.techType}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {techTypeDropdown.map((element: any) => (
                <Dropdown.Item eventKey={element}>{element}</Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>

        <div className="col-md-4">
          <label htmlFor="inputName4" className="form-label">
            {deliveryManagerLabel}
          </label>
          <span className="required">{requiredFeild.required}</span>

          <div style={{ height: "1rem" }}>
            <Select
              className="dropdown-select"
              options={managerOptions}
              isSearchable={true}
              onChange={handleReportingManager}
            />
          </div>
        </div>

        <div className="col-md-4">
          <label htmlFor="inputName4" className="form-label">
            {hrBusinessPartnerLabel}
          </label>
          <span className="required">{requiredFeild.required}</span>

          <Select
            className="dropdown-select"
            options={hrbpOptions}
            isSearchable={true}
            onChange={handleHrbpManager}
          />
        </div>

        {/* <div className="col-md-4">
          <label htmlFor="inputName4" className="form-label">
            {projectStartDateLabel}
          </label>
          <span className="required">{requiredFeild.required}</span>
          <input
            type="date"
            max={moment(projectData.projectEndDate)
              .subtract(1, "day")
              .format("YYYY-MM-DD")}
            className="form-control"
            value={projectData.projectStartDate}
            onChange={(e) =>
              setProjectData({
                ...projectData,
                projectStartDate: e.target.value,
              })
            }
          />
        </div> */}

        {/* <div className="col-md-4">
          <label htmlFor="inputName4" className="form-label">
            {projectEndDateLabel}
          </label>
          <input
            min={moment(projectData.projectStartDate)
              .add(1, "day")
              .format("YYYY-MM-DD")}
            type="date"
            className="form-control"
            value={projectData.projectEndDate}
            onChange={(e) =>
              setProjectData({
                ...projectData,
                projectEndDate: e.target.value,
              })
            }
          />
        </div> */}

        {/* <div className="col-md-4">
          <label htmlFor="inputName4" className="form-label">
            {projectStatusLabel}
          </label>
          <span className="required">{requiredFeild.required}</span>
          <Dropdown
            onSelect={(eventKey: any) =>
              setProjectData({
                ...projectData,
                status: eventKey,
              })
            }
          >
            <Dropdown.Toggle variant="light" className="form-control">
              {projectData.status}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {addProjectStatusDropdown.map((element: any) => (
                <Dropdown.Item eventKey={element}>{element}</Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div> */}

        {/* <div className="col-md-4">
          <label htmlFor="inputName4" className="form-label">
            {purchaseOrderNoLabel}
          </label>
          <input
            type="text"
            className="form-control"
            value={projectData.poNumber}
            onChange={(e) =>
              setProjectData({
                ...projectData,
                poNumber: e.target.value,
              })
            }
          />
          <p className="error">{errors.poNumber}</p>
        </div> */}

        {/* <div className="col-md-4 mb-3">
          <label htmlFor="inputName4" className="form-label">
            {poStartDateLabel}
          </label>
          <input
            type="date"
            max={moment(projectData.poEndDate)
              .subtract(1, "day")
              .format("YYYY-MM-DD")}
            className="form-control"
            value={projectData.poStartDate}
            onChange={(e) =>
              setProjectData({
                ...projectData,
                poStartDate: e.target.value,
              })
            }
          />
        </div> */}
        {/* <div className="col-md-4 mb-3">
          <label htmlFor="inputName4" className="form-label">
            {poEndDateLabel}
          </label>
          <input
            min={moment(projectData.poStartDate)
              .add(1, "day")
              .format("YYYY-MM-DD")}
            type="date"
            className="form-control"
            value={projectData.poEndDate}
            onChange={(e) =>
              setProjectData({
                ...projectData,
                poEndDate: e.target.value,
              })
            }
          />
        </div> */}

        <div className="col-md-4">
          <label htmlFor="inputName4" className="form-label">
            Actual HC
          </label>
          <input
            type="text"
            className="form-control"
            value={projectData.actualHc}
            disabled
            onChange={(e) =>
              setProjectData({
                ...projectData,
                actualHc: e.target.value.replace(/\D/g, ""),
              })
            }
          />
          <p className="error">{errors.actualHc}</p>
        </div>
        <div className="col-md-4 mb-3">
          <label htmlFor="inputName4" className="form-label">
            {approvedHcLabel}
          </label>
          <input
            type="text"
            className="form-control"
            value={projectData.approvedHc}
            onChange={(e) =>
              setProjectData({
                ...projectData,
                approvedHc: e.target.value.replace(/\D/g, ""),
              })
            }
          />
          <p className="error">{errors.approvedHc}</p>
        </div>
        {/* <div className="col-md-4">
          <label htmlFor="inputName4" className="form-label">
            {currencyTypeLabel}
          </label>
          <Dropdown
            onSelect={(eventKey: any) =>
              setProjectData({
                ...projectData,
                poValueIn: eventKey,
              })
            }
          >
            <Dropdown.Toggle variant="light" className="form-control">
              {projectData.poValueIn}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {poValueInDropdown.map((element: any) => (
                <Dropdown.Item eventKey={element}>{element}</Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div> */}
        {/* <div className="col-md-4">
          <label htmlFor="inputName4" className="form-label">
            {billingStatusLabel}
          </label>
          <Dropdown
            onSelect={(eventKey: any) =>
              setProjectData({
                ...projectData,
                billingRate: eventKey,
              })
            }
          >
            <Dropdown.Toggle variant="light" className="form-control">
              {projectData.billingRate}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {billingRateDropdown.map((element: any) => (
                <Dropdown.Item eventKey={element}>{element}</Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div> */}
        {/* <div className="col-md-4">
          <label htmlFor="inputName4" className="form-label">
            {billingRateLabel}
          </label>
          <input
            type="text"
            className="form-control"
            value={projectData.poAmount}
            onChange={(e) =>
              setProjectData({
                ...projectData,
                poAmount: e.target.value,
              })
            }
          />
          <p className="error">{errors.poAmount}</p>
        </div> */}
        <div className="col-md-4">
          <label htmlFor="inputName4" className="form-label">
            {spocPersonNameLabel}
          </label>
          <input
            type="text"
            className="form-control"
            value={projectData.spocPersonName}
            onChange={(e) =>
              setProjectData({
                ...projectData,
                spocPersonName: e.target.value,
              })
            }
          />
          <p className="error">{errors.spocPersonName}</p>
        </div>
        <div className="col-md-4">
          <label htmlFor="inputName4" className="form-label">
            {spocContactNumberLabel}
          </label>
          <input
            type="text"
            maxLength={projectData.geography == "India" ? 10 : 15}
            className="form-control"
            value={projectData.spocNumber}
            onChange={(e) =>
              setProjectData({
                ...projectData,
                spocNumber: e.target.value,
              })
            }
          />
          <p className="error">{errors.spocNumber}</p>
        </div>
        <div className="col-md-4">
          <label htmlFor="inputName4" className="form-label">
            {spocEmailIDLabel}
          </label>
          <input
            type="email"
            className="form-control"
            value={projectData.spocEmail}
            onChange={(e) =>
              setProjectData({
                ...projectData,
                spocEmail: e.target.value,
              })
            }
          />
          <p className="error">{errors.spocEmail}</p>
        </div>
        <div className="col-md-4">
          <label htmlFor="inputName4" className="form-label">
            {remarksLabel}
          </label>
          <input
            type="text"
            value={projectData.remarks}
            className="form-control"
            onChange={(e) =>
              setProjectData({
                ...projectData,
                remarks: e.target.value,
              })
            }
          />
        </div>
        <div className="modal-btn-wrapper mt-5 mx-auto">
          <div>
            <button
              className="btn cancel-btn buttonsize"
              onClick={hideAddProject}
            >
              {cancel}
            </button>
          </div>
          <div>
            <button
              className={
                btnDisable
                  ? "btn add-submit-button buttonsize"
                  : "btn add-submit-button btn-disabled buttonsize"
              }
              onClick={handleInvoiceSubmit}
            >
              {submit}
            </button>
          </div>
        </div>
      </div>
      <ClientManagerModal 
        show={showClientManager}
        onHide={() => setShowClientManager(false)}
        data={clientOptions}
        refreshData={() => dispatch(actions.getClientNameAction())}
      />
    </>
  );
};

export default AddProject;
